import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleXmark, faSpinner } from "@fortawesome/free-solid-svg-icons"


export const EmptyFrame = ({message="Sorry, no data avaiable."}) => {
  return (
    <div className="frame_empty">
      <FontAwesomeIcon icon={faCircleXmark} />
      <p className="empty_msg">{message}</p>
    </div>
  )
}

export const LoadingFrame = () => {
  return (
    <div className="frame_empty">
      <FontAwesomeIcon icon={faSpinner} spin />
    </div>
  )
}
